/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Recipient_Updated_ToastInputs */



/**
* | output |
* | --- |
* | "Event recipient updated successfully" |
*
* @param {Speakers_Recipient_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_recipient_updated_toast = /** @type {((inputs?: Speakers_Recipient_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Recipient_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Destinataire de l'evenement mis a jour avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisempfänger erfolgreich aktualisiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il destinatario dell'evento è stato aggiornato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Получатель события успешно обновлен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El destinatario del evento se actualizó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件接收人已成功更新")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの受信者が正常に更新されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट प्राप्तकर्ता को सफलतापूर्वक अपडेट कर दिया गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O destinatário do evento foi atualizado com sucesso.")
	return /** @type {LocalizedString} */ ("Event recipient updated successfully")
});